export function Sort(items) {
  items.sort((a, b) => b.isPublic - a.isPublic);

  return items;
}
